/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefendedPointCaalDal = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12 3 5 6.455v4.181C5 15.43 7.7 19.912 12 21c4.3-1.088 7-5.57 7-10.364V6.455zm0 9h5c-.442 3.558-1.9 6.007-5 7zH7V7.5L12 5z" /></svg>;
export default SvgDefendedPointCaalDal;